import * as process from 'process'

export function getVersion(): string {
  return typeof process.env.APP_ENV === 'undefined'
    ? 'dev'
    : (process.env.APP_ENV as string)
}
